import CustomSignInState from "@husky-hrc/Framework/Store/Data/SignIn/SignInState";
import { ExternalSignInModel } from "@husky-hrc/Framework/Types/ApiModel";
import Constants from "@husky-hrc/Utilities/Constants";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { assignById } from "@insite/client-framework/Store/Data/DataState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

const initialState: CustomSignInState = {
    isLoading: {},
    byId: {},
    dataViews: {},
    isSigningInAsGuest: false,
};

const reducer = {} as any;

reducer[Constants.Actions.BeginLoadExternalProvidersWithReturn] = (
    draft: Draft<CustomSignInState>,
    action: { id: string },
) => {
    draft.isLoading[action.id] = true;
};

reducer[Constants.Actions.CompleteLoadExternalProvidersWithReturn] = (
    draft: Draft<CustomSignInState>,
    action: { model: ExternalSignInModel },
) => {
    delete draft.isLoading[action.model.id];
    assignById(draft, action.model);
};

const signInReducer = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).signIn = signInReducer;
